var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "master-filter hideSmartphone"
  }, [_c('div', {
    staticClass: "dropdown-title"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "dropdown w-dropdown",
    attrs: {
      "data-hover": "false",
      "data-delay": "0"
    }
  }, [_c('b-dropdown', {
    ref: "dropdown-filters",
    attrs: {
      "size": "sm",
      "variant": "link",
      "toggle-class": "text-decoration-none",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-dropdown-toggle"
        }, [_c('div', {
          staticClass: "icon w-icon-dropdown-toggle"
        }), _c('div', {
          staticClass: "dropdown-placeholder"
        }, [_vm._v(" " + _vm._s(_vm.active.name) + " ")])])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.options, function (item, key) {
    return _c('b-dropdown-item', {
      key: key,
      staticClass: "drop",
      "class": [_vm.active === item ? 'active-filter' : ''],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          return _vm.filterClient(item);
        }
      }
    }, [_c('div', {
      staticClass: "text-block-4 fnt-13",
      attrs: {
        "id": "forEmployee"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }